export const SET_DATA = 'GAME_HISTORY:DATA:SET';
export const EXPORT_TRANSACTIONS = 'GAME_HISTORY:TRANSACTIONS:EXPORT';

export const setMaxPage = max => ({
    type: SET_DATA,
    payload: {
        max,
        page: 1
    }
});

export const setData = (data) => ({
    type: SET_DATA,
    payload: data
});

export const setProduct = (product) => ({
    type: SET_DATA,
    payload: {
        product
    }
});

export const setGamesSource = (gamesSource) => ({
    type: SET_DATA,
    payload: {
        gamesSource
    }
});

export const toggleLoading = (isLoading) => ({
    type: SET_DATA,
    payload: {
        isLoading
    }
});

export const setPeriodData = ({ period, startDate, endDate }) => ({
    type: SET_DATA,
    payload: {
        period,
        startDate,
        endDate
    }
});

export const exportTransactions = (data) => ({
    type: EXPORT_TRANSACTIONS,
    payload: data
});
